import { StyleSheet } from 'aphrodite';
export const styles = StyleSheet.create({
    page: {
        minWidth: "100%",
        display: "grid",
        gridTemplateRows: "min-content min-content auto"
    },
    searchBox: {
        minWidth: "350px",
        maxWidth: "400px",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "10px",
        marginBottom: "10px",
        paddingLeft: "10px",
        paddingRight: "10px"
    },
    facultyList: {
        display: "grid",
        gridTemplateColumns: "repeat(5,auto)",
        gridColumnGap: "5px"
    },
    loader: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    itemContainer: {
        boxSizing: "border-box",
        padding: "10px",
        paddingLeft: "20px",
        ":hover": {
            backgroundColor: "#f7f7f7"
        }
    },
    name:  {
        fontSize: "16px"
    },
    affiliation: {
        fontSize: "12px"
    }
})


// WEBPACK FOOTER //
// ./src/pages/FacultyListPageStyles.ts